/**
 * Implements MyPositions based on covalent api
 */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAccount, useNetwork } from 'wagmi';
import { IStore } from '../../../reducers';
import MyPositionsTable from './Table';
import MyPositionsTableMobile from './TableMobile';
import { ETableTimeframe } from '../helpers';
import { switchCurrentTicker } from '../../../Authlogic';
import useGetMyPositions, { IMyPosition } from './useGetMyPositions';

interface IMyPositionProps {
  width?: number;
  isMobile?: boolean;
}

/**
 * Data-layer wrapper
 * @param param0
 * @returns
 */
const MyPositionsDataLayer = ({ width, isMobile }: IMyPositionProps) => {
  const { address } = useAccount();
  const { chain } = useNetwork();
  const timezone = useSelector((state: IStore) => state.timezone.current);
  const loggedIn = useSelector((state: IStore) => state.auth.loggedIn);

  const [timeframe, setTimeframe] = useState(
    isMobile ? ETableTimeframe.MONTH : ETableTimeframe.WEEK
  );

  const onSetTimeframe = (time: ETableTimeframe) => setTimeframe(time);

  const { data, loading } = useGetMyPositions({
    address,
    chain: chain?.id,
    timeframe,
  });

  const onTradeClick = ({ ticker }: IMyPosition) => {
    if (ticker) {
      switchCurrentTicker(ticker);
    }
  };

  return isMobile ? (
    <MyPositionsTableMobile
      swaps={data}
      loading={loading}
      timezone={timezone}
      onTradeClick={onTradeClick}
    />
  ) : (
    <MyPositionsTable
      swaps={data}
      timeframe={timeframe}
      loading={loading}
      loggedIn={loggedIn}
      timezone={timezone}
      width={width}
      handleSetTimeframe={onSetTimeframe}
      onTradeClick={onTradeClick}
    />
  );
};

export default MyPositionsDataLayer;
